import { render } from "./RecentTransactionCard.vue?vue&type=template&id=b6d1ee2a&scoped=true"
import script from "./RecentTransactionCard.vue?vue&type=script&lang=js"
export * from "./RecentTransactionCard.vue?vue&type=script&lang=js"

import "./RecentTransactionCard.vue?vue&type=style&index=0&id=b6d1ee2a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d1ee2a"]])

export default __exports__